// /Users/shawn/💼_WORKSPACE/Projects/FixPriceAI-Desktop/src/index.js
// Purpose: React DOM entry point for FixPriceAI Desktop
// NOT for: Electron main process or Node.js logic

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);